import React, { Component } from 'react';
import { Spinner, translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { getMyEducationGroups } from 'actions/groups';

class GroupSelector extends Component {
	constructor(props) {
		super(props);

		this.state = {
			error: '',
			groups: [],
		};
	}

	onGroupSelect = (event, id) => {
		if (this.props.required) {
			if (event.target != null) {
				if (event.target.value === '' || event.target.value === '0') {
					this.setState({ error: this.props.translate('field-needs-input') });
					return;
				} else {
					this.setState({ error: '' });
				}
			}
		}

		if (event) {
			if (event.target != null) {

				if (this.props.onChange) {
					let groups = this.state.groups;
					let group = groups.find((x) => x.id == event.target.value);
					if (group) {
						this.props.onChange(event.target.value, group);
					} else {
						this.props.onChange(event.target.value);
					}

				}
			}
		}

		if (id && id != '0') {
			if (this.props.onChange) {
				this.props.onChange(id);
			}
		}
	};

	groupOptions = (groups) => {
		return groups.map((group, i) => {

			if (
				group.classroomUrl == null ||
				(group.classroomUrl == '' && this.props.sectionId == null)
			) {
				return (
					<option key={`group-select-${i}`} disabled value={group.id}>
						{`${group.title} (${this.props.translate('Workspace missing')})`}
					</option>
				);
			}

			if (group.userRole == 'OWNER') {
				if (this.props.sectionId == null || this.props.cloneView) {
					return (
						<option key={`group-select-${i}`} value={group.id}>
							{group.title}
						</option>
					);
				}

				if (this.props.sectionId == group.id) {
					return (
						<option key={`group-select-${i}`} value={group.id}>
							{group.title}
						</option>
					);
				}

				return (
					<option key={`group-select-${i}`} value={group.id}>
						{group.title}
					</option>
				);
			}
		});
	};

	componentDidMount = async () => {
		const { sectionId } = this.props;

		var groups = await this.props.getMyEducationGroups();
		this.setState({ groups: groups });

		if (sectionId != null && sectionId != 0) {
			let group = groups.find((x) => x.id == sectionId);
			if (group) {
				this.props.onChange(sectionId, group);
			} else {
				this.props.onChange(sectionId);
			}

		}
	};

	render() {
		const { sectionId, disabled, required } = this.props;
		const { error } = this.state;
		const { groups } = this.state;

		if (groups == null)
			return <Spinner center />;

		return (
			<div>
				<label>
					{this.props.translate('section')}
					{required ? '*' : null}
				</label>
				<div className='select'>
					<select
						name='grup'
						id='groups-selector'
						value={sectionId ? sectionId : ''}
						onChange={this.onGroupSelect}
						disabled={disabled}
					>
						<option value='0'>{this.props.translate('select-an-alternative')}</option>
						{this.groupOptions(groups)}
					</select>

					{required && error !== '' ? (
						<div>
							<span style={{ marginTop: '1rem', color: 'red' }}>{error}</span>
						</div>
					) : null}
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		translate: translate(state.Languages.translations),
	};
}

export default connect(mapStateToProps, { getMyEducationGroups })(GroupSelector);
